
import { MenuItem } from "@/types";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const Auth = namespace("auth");

@Component({
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  }
})
export default class Default extends Vue {
  @Auth.Getter("getUser") getUser!: any;
  topItems: Array<MenuItem> = [
    { title: "HOME", icon: "mdi-home", pageName: "CourseEvents", exact: true },
    { title: "COMPANIES", icon: "mdi-domain", pageName: "CompaniesList" },
    {
      title: "DELEGATES",
      icon: "mdi-account-multiple",
      pageName: "DelegatesList"
    }
  ];
  coursesMenu: Array<MenuItem> = [
    {
      title: "PHYSICAL COURSES",
      icon: "mdi-school",
      pageName: "CoursesList"
    },
    {
      title: "ONLINE COURSES",
      icon: "mdi-cast-education",
      pageName: "OnlineCoursesList"
    },
    {
      title: "AUDITS",
      icon: "mdi-calendar-month",
      pageName: "AuditsList"
    }
  ];
  bottomItems: Array<MenuItem> = [
    {
      title: "CERTIFICATES MANAGER",
      icon: "mdi-seal",
      pageName: "Certificate"
    },
    {
      title: "EQUIPMENT FITMENT",
      icon: "mdi-wrench-outline",
      pageName: "EquipmentFitment"
    },
    {
      title: "INSTRUCTORS",
      icon: "mdi-account-box",
      pageName: "Instructors"
    },
    {
      title: "CHAT",
      icon: "mdi-chat-outline",
      pageName: "Chat"
    },
    {
      title: "QUOTES",
      icon: "mdi-clipboard-edit-outline",
      pageName: "Quotes"
    },
    {
      title: "INVOICES",
      icon: "mdi-file-document-outline",
      pageName: "Invoices"
    }
  ];
  reportsMenu: Array<MenuItem> = [
    { title: "DASHBOARD", icon: "mdi-signal-cellular-3", pageName: "Reports" },
    { title: "EARNINGS", icon: "mdi-piggy-bank-outline", pageName: "Earnings" },
    { title: "TARGETS", icon: "mdi-check-circle", pageName: "Targets" },
    {
      title: "PROGRESS TRACKER",
      icon: "mdi-chart-pie",
      pageName: "CoursesProgress"
    }
  ];
  settingsMenu: Array<MenuItem> = [
    { title: "USER ROLES", icon: "mdi-account-lock", pageName: "UserRoles" },
    { title: "USERS", icon: "mdi-account-multiple", pageName: "Users" },
    {
      title: "COMPANY INFO",
      icon: "mdi-border-color",
      pageName: "CompanyInfo"
    },
    {
      title: "OFF-SITE RATES",
      icon: "mdi-currency-usd",
      pageName: "ExpenseRates",
      permission: "manage_expense_rates"
    },
    {
      title: "ITEM MASTER",
      icon: "mdi-package-variant-closed",
      pageName: "ItemMaster",
      permission: "view_item_master"
    },
    {
      title: "VEHICLE CATEGORIES",
      icon: "mdi-truck-outline",
      pageName: "VehicleCategories",
      permission: "view_vehicle_categories"
    }
  ];

  get visibleSettingsMenu(): Array<MenuItem> {
    const permissions = (this.getUser && this.getUser.permissions) || [];
    return this.settingsMenu.filter(
      item => !item.permission || permissions.includes(item.permission)
    );
  }

  @Auth.Action("authLogout")
  authLogout!: () => Promise<void>;

  get isMobile() {
    return !this.$vuetify.breakpoint.mdAndUp;
  }

  set drawer(val: boolean) {
    this.$emit("toggle", val);
  }
  get drawer() {
    return this.$props.isOpen;
  }

  controller(pageName: string): void {
    if (pageName) {
      if (pageName === "logout") {
        this.authLogout().then(() => {
          location.reload();
        });
      } else {
        if (pageName !== this.$route.name) {
          this.$router.push({ name: pageName });
        }
      }
    }
  }
}
